import { AfterViewInit, Component, TemplateRef, ViewChild } from '@angular/core';
import { RoutePath } from '@common';
import { AuthService, TemplateRegistryService, TemplateType } from '@common/services';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html'
})
export class AppLayoutComponent implements AfterViewInit {
  protected readonly RoutePath = RoutePath;
  protected readonly TemplateType = TemplateType;

  @ViewChild('backupJobTransferredTRef', { static: true }) private backupTRef!: TemplateRef<unknown>;
  @ViewChild('deleteJobTransferredTRef', { static: true }) private deleteTRef!: TemplateRef<unknown>;
  @ViewChild('exportJobTransferredTRef', { static: true }) private exportTRef!: TemplateRef<unknown>;
  @ViewChild('restoreJobTransferredTRef', { static: true }) private restoreTRef!: TemplateRef<unknown>;

  constructor(
    private authService: AuthService,
    private templateRegistry: TemplateRegistryService
  ) {}

  get prefix(): string {
    return this.authService?.prefix;
  }

  ngAfterViewInit(): void {
    this.registerTemplate();
  }

  private registerTemplate(): void {
    const templates: [TemplateType, TemplateRef<unknown>][] = [
      [TemplateType.Backup, this.backupTRef],
      [TemplateType.Delete, this.deleteTRef],
      [TemplateType.Export, this.exportTRef],
      [TemplateType.Restore, this.restoreTRef]
    ];

    templates.forEach(([type, ref]) => this.templateRegistry.registerTemplate(type, ref));
  }
}
